import { inject, observer } from 'mobx-react'
import * as React from 'react'
import stepList from '../../constants/steps'
import { ILayoutStore } from '../../store/LayoutStore'

interface IArianeFeedProps {
  LayoutStore?: ILayoutStore
}

@inject('LayoutStore')
@observer
class ArianeFeed extends React.Component<IArianeFeedProps> {
  public constructor(props: IArianeFeedProps) {
    super(props)
  }

  public componentDidUpdate() {
    this.getProgressHeight()
  }

  public render() {
    const arianeFeedStepCount = this.getArianeFeedStepCount()

    // Create a simple array for the total step number
    const steps = Array.from({ length: arianeFeedStepCount }, (v, k) => k + 1)

    return (
      <div className="ArianeFeed">
        <div className="ArianneFeed-items">
          <span
            className="ArianeFeed-progress"
            style={{
              top: `${(100 / (stepList.length - 2)) *
                this.props.LayoutStore!.arianeFeedStepCount}%`,
            }}
          />
          {steps.map((item, index) => {
            return (
              <div className="ArianeFeed-step " key={`ArianeFeed-${index}`}>
                <p
                  className="ArianeFeed-hiddenText"
                  aria-hidden={
                    this.props.LayoutStore!.arianeFeedStepCount === index
                      ? 'false'
                      : 'true'
                  }
                >{`Etape ${index} sur ${stepList.length}`}</p>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  private getProgressHeight() {
    const height =
      100 / this.props.LayoutStore!.arianeFeedStepCount + stepList.length
    return height
  }

  private getArianeFeedStepCount(): number {
    let arianeFeedStepCount = 0

    stepList.map((element, index) => {
      if (element.isArianeFeedStep) {
        arianeFeedStepCount++
      }
    })

    return arianeFeedStepCount
  }
}

export default ArianeFeed



// WEBPACK FOOTER //
// ./src/components/ArianeFeed/ArianeFeed.tsx